import { useEffect } from 'react';
import { useDebouncedCallback } from './useDebouncedCallback';
export const useWindowResizeEvent = onResize => {
  const debounceOnResize = useDebouncedCallback(onResize);
  useEffect(() => {
    window.addEventListener('resize', debounceOnResize);
    return () => {
      window.removeEventListener('resize', debounceOnResize);
    };
  }, [debounceOnResize]);
};
export const useWindowScrollEvent = onScroll => {
  const debounceOnScroll = useDebouncedCallback(onScroll);
  useEffect(() => {
    window.addEventListener('scroll', debounceOnScroll, true);
    return () => {
      window.removeEventListener('scroll', debounceOnScroll, true);
    };
  }, [debounceOnScroll]);
};